// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenToolbarAction_root__2ZQ3_","icon":"ScreenToolbarAction_icon__19bdG","label":"ScreenToolbarAction_label__2URSN"};